var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon icon-reset",attrs:{"title":_vm.$t('button.reset')},on:{"click":_vm.doReset}})}
var staticRenderFns = []

export { render, staticRenderFns }